<template>
  <li
    class="tw-relative tw-my-0.5 tw-flex tw-h-auto tw-w-full tw-items-center tw-justify-start tw-border-t tw-border-t-dorian-gray-50 tw-bg-white tw-pb-2 tw-pt-2 dark:tw-border-t-dorian-gray-100"
  >
    <a
      class="tw-inline-flex tw-h-full tw-w-full tw-rounded tw-bg-white tw-px-2 tw-py-2 tw-no-underline tw-transition-colors hover:tw-bg-dorian-gray-50/40 dark:hover:tw-bg-dorian-gray-100/60"
      :href="props.link"
      :target="props.target"
      :data-test-id="props.dataTestId"
    >
      <div class="tw-relative tw-inline-flex tw-items-center tw-justify-start">
        <span class="tw-font-normal tw-text-dorian-gray-500">
          <slot></slot>
        </span>
        <span class="tw-ml-4 tw-font-normal tw-text-dorian-gray-500">
          {{ label }}
        </span>
      </div>
    </a>
  </li>
</template>

<script lang="ts" setup>
export interface HeaderDropdownLinkProps {
  label: string;
  link: string;
  target?: string;
  dataTestId?: string;
}

const props = withDefaults(defineProps<HeaderDropdownLinkProps>(), {
  target: "_self",
  dataTestId: "",
});
</script>

<style scoped></style>
